if (!customElements.get("half-product-image-mod")) {
  customElements.define(
    "half-product-image-mod",
    class HalfProductImageMod extends HTMLElement {
        constructor() {
            super()
            this.imageListDom = this.querySelector('.image-list');
            this.productListDom = this.querySelector('.product-list');
            this.init();
        }

        init() {
            if (this.imageListDom && this.productListDom) {
                this.imageListDom.changeIndex = (index) => {
                    this.productListDom?.setActiveItem(index)
                }
                this.productListDom.changeIndex = (index) => {
                    this.imageListDom?.setActiveItem(index)
                }
            }
        }

    })
}

if (!customElements.get("swiper-list")) {
  const curDocDom = window.document.documentElement
  customElements.define(
    "swiper-list",
    class SwiperList extends HTMLElement {
        constructor() {
            super()
            this.isMobile = window.FoxTheme.config.mqlMobile || window.FoxTheme.config.mqlTablet
            this.startPageX = null
            this.curLeft = 0;
            this.curIndex = 0;
            this.curIndexForPointer = 0;
            this.listDom = this.querySelector('.swiper-list-content')
            this.pointerDoms = this.querySelectorAll('.swiper-pointer')
            this.leftArrowBtnDom = this.querySelector('.switch-button.left')
            this.rightArrowBtnDom = this.querySelector('.switch-button.right')
            this.init()
        }

        init() {
            this.listDom.classList.add('smooth')
            this.initEvent()
        }

        initEvent() {
            if (!this.isMobile) {
                this.addEventListener('mousedown', this.handleMouseDown)
            } else {
                this.addEventListener('touchstart', this.handleMouseDown)
            }
            this.pointerDoms?.forEach((dom, i) => {
                dom.addEventListener('click', () => {
                    this.handlePointerClick(i)
                })
            })
            window.addEventListener('resize', FoxTheme.utils.debounce(this.handleResize.bind(this), 100))
            if (this.leftArrowBtnDom) {
                this.leftArrowBtnDom.addEventListener('click', this.handlePrevBtnClick.bind(this))
            }
            if (this.rightArrowBtnDom) {
                this.rightArrowBtnDom.addEventListener('click', this.handleNextBtnClick.bind(this))
            }
        }

        getChildrenCount() {
            const childrenCount = this.listDom.children.length
            return childrenCount
        }

        getActualIndex(index) {
            const childrenCount = this.getChildrenCount()
            return Math.min(Math.max(index, 0), childrenCount - 1)
        }

        getDiffIndexByDiffX(diffX) {
            if (!diffX) return 0
            const domWidth = this.clientWidth
            const absDiffX = Math.abs(diffX) 
            let diffIndex = Math.floor(absDiffX / domWidth)
            diffIndex = diffX > 0 ? -diffIndex : diffIndex
            const restDiff = absDiffX % domWidth
            if (restDiff > domWidth / 2) {
                diffIndex += diffX > 0 ? -1 : 1
            }
            return diffIndex
        }

        handleScroll(newIndex) {
            if (newIndex == null) return
            const domWidth = this.clientWidth
            this.curLeft = -(this.curIndex * domWidth)
            this.listDom.style.transform = `translate3d(${this.curLeft}px, 0,0)`
        }

        handleResize() {
            this.handleScroll(this.curIndex)
            this.isMobile = window.FoxTheme.config.mqlMobile || window.FoxTheme.config.mqlTablet
            if (!this.isMobile) {
                this.addEventListener('mousedown', this.handleMouseDown)
                this.removeEventListener('touchstart', this.handleMouseDown)
            } else {
                this.addEventListener('touchstart', this.handleMouseDown)
                this.removeEventListener('mousedown', this.handleMouseDown)
            }
        }

        handlePrevBtnClick() {
            this.curIndex = this.getActualIndex(this.curIndex - 1);
            this.handleScroll(this.curIndex)
            this.updateActivePointer(this.curIndex);
            this.changeIndex?.(this.curIndex);
            if (!this.curIndex) {
                this.leftArrowBtnDom.classList.add('hidden')
                this.rightArrowBtnDom.classList.remove('hidden')
            }
        }

        handleNextBtnClick() {
            this.curIndex = this.getActualIndex(this.curIndex + 1);
            this.handleScroll(this.curIndex)
            this.updateActivePointer(this.curIndex);
            this.changeIndex?.(this.curIndex);
            if (this.curIndex === this.getChildrenCount() - 1) {
                this.rightArrowBtnDom.classList.add('hidden')
                this.leftArrowBtnDom.classList.remove('hidden')
            }
        }

        handleToggleBtn () {
            if (!this.leftArrowBtnDom) return
            if (this.curIndex) {
                this.leftArrowBtnDom.classList.remove('hidden')
                if (this.curIndex < this.getChildrenCount() - 1) {
                    this.rightArrowBtnDom.classList.remove('hidden')
                } else {
                    this.rightArrowBtnDom.classList.add('hidden')
                }
            } else {
                this.leftArrowBtnDom.classList.add('hidden')
                this.rightArrowBtnDom.classList.remove('hidden')
            }
        }

        handleMouseDown = (e)=> {
            this.listDom.classList.remove('smooth')
            this.startPageX = e.changedTouches?.[0]?.pageX ?? e.pageX
            if (this.isMobile) {
                curDocDom.addEventListener('touchmove', this.handleMouseMove)
                curDocDom.addEventListener('touchend', this.handleMouseUp)
            } else {
                curDocDom.addEventListener('mousemove', this.handleMouseMove)
                curDocDom.addEventListener('mouseup', this.handleMouseUp)
            }
        }

        handleMouseMove = (e) => {
            if (this.startPageX === null) return
            const pageX = e.changedTouches?.[0]?.pageX ?? e.pageX
            const diffX = pageX - this.startPageX
            this.listDom.style.transform = `translate3d(${diffX + this.curLeft}px, 0,0)`
            if (diffX) {
                const diffIndex = this.getDiffIndexByDiffX(diffX)
                const newIndex = this.getActualIndex(diffIndex + this.curIndex, 0)
                this.updateActivePointer(newIndex)
                this.changeIndex?.(newIndex)
            }
        }

        handleMouseUp = (e) => {
            this.listDom.classList.add('smooth')
            const pageX = e.changedTouches?.[0]?.pageX ?? e.pageX
            const diffX = pageX - this.startPageX
            this.curLeft += diffX
            if (this.curLeft > 0) {
                this.listDom.style.transform = `translate3d(0,0,0)`
                this.curLeft = 0
                this.curIndex = 0
            } else if (diffX) {
                const domWidth = this.clientWidth
                const absDiffX = Math.abs(diffX) 
                if (absDiffX > domWidth / 2) {
                    const diffIndex = this.getDiffIndexByDiffX(diffX)
                    this.curIndex = this.getActualIndex(diffIndex + this.curIndex, 0)
                    this.updateActivePointer(this.curIndex)
                    this.changeIndex?.(this.curIndex)
                }
            }
            this.handleScroll(this.curIndex)
            this.handleToggleBtn()
            this.startPageX = null
            if (this.isMobile) {
                curDocDom.removeEventListener('touchmove', this.handleMouseMove)
                curDocDom.removeEventListener('touchend', this.handleMouseUp)
            } else {
                curDocDom.removeEventListener('mousemove', this.handleMouseMove)
                curDocDom.removeEventListener('mouseup', this.handleMouseUp)
            }
        }

        updateActivePointer(newIndex) {
            if (newIndex == null) return
            if (!this.pointerDoms?.length) return
            if (this.pointerDoms[newIndex]) {
                this.pointerDoms[this.curIndexForPointer].classList.remove('active')
                this.pointerDoms[newIndex].classList.add('active')
                this.curIndexForPointer = newIndex
            }
        }

        handlePointerClick(index) {
            this.setActiveItem(index)
            this.changeIndex?.(index)
        }

        setActiveItem(index) {
            if (index == null) return
            this.updateActivePointer(index)
            const domWidth = this.clientWidth
            this.curLeft = -(index * domWidth)
            this.listDom.style.transform = `translate3d(${this.curLeft}px,0,0)`
            this.curIndex = index;
            this.handleToggleBtn()
        }
    })
}